export class FotoRequest {
  Image!: string;
  Width!: number;
  Height!: number;
  Top!: number;
  Left!: number;
  MaxWidth?: number;
  MaxHight?: number;
  constructor(obj?: Partial<FotoRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
